import { Card } from '@/types/Card';
import { taishinCards } from './banks/taishin';
import { fubonCards } from './banks/fubon';
import { esunCards } from './banks/esun';
import { sinoCards } from './banks/sino';
import { hsbcCards } from './banks/hsbc';
import { ctbcCards } from './banks/ctbc';
import { ubotCards } from './banks/ubot';
import { dbsCards } from './banks/dbs';
import { americanExpressCards } from './banks/americanExpress';

/**
 * Get card objects by their IDs
 * @param ids Array of card IDs or card key constants
 * @returns Array of Card objects
 */
export function getCardsByIds(ids: string[] | undefined): Card[] {
  if (!ids) return [];
  return ids.map(id => cards[id]).filter(Boolean);
}

export const cards: { [key: string]: Card } = {
  ...taishinCards,
  ...fubonCards,
  ...esunCards,
  ...sinoCards,
  ...hsbcCards,
  ...ctbcCards,
  ...ubotCards,
  ...dbsCards,
  ...americanExpressCards,
};
